import styled, { createGlobalStyle } from "styled-components"
import Breakpoints from "./breakpoints"

export const SidebarContainer = styled.div`
  @media (min-width: ${Breakpoints.lg}) {
    display: none;
  }

  visibility: ${props => (props.isVisible ? "visible" : "hidden")};

  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
  background: lightgrey;
  transition: all 0.5s ease;
  transform: translateX(${props => (props.isVisible ? "0" : "100vw")});
`
export const LayoutContainer = styled.div`
  position: relative;
  max-width: 100vw;
  overflow-x: hidden;
  background-color: #fff;
`
export const DisableBodyScroll = createGlobalStyle`
  html {
    overflow-y: ${props => (props.enabled ? "hidden" : "scroll")};
  }
`
